<template>
  <div class="home">
    <div class="title-container">
      <img src="img/LeftBanner.png" alt="banner"/>
    </div>
    <div class="wheel-container">
      <SpinningWheel ref="wheel"/>
    </div>
    <div class="button-container">
      <div
        :class="$store.state.spinning ? 'button disabled' : 'button'"
        @click="spin"
      />
    </div>
  </div>
</template>

<script>
import SpinningWheel from '@/components/SpinningWheel.vue';

export default {
  name: 'HomeView',
  components: {
    SpinningWheel,
  },
  methods: {
    spin() {
      this.$refs.wheel.startSpinning();
    },
  },
};
</script>

<style scoped>
.button-container .button {
  background-image: url('@/assets/SpinButton.png');
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 4.25vh;
  height: calc(21vh);
  position: absolute;
  right: 4.25vh;
  width: calc(21vh);
}

.button-container .button.disabled {
  opacity: 0.2;
}

.home {
  display: flex;
  height: 100%;
  width: 100%;
}

.title-container,
.button-container {
  width: 10%;
}

.title-container {
  display: flex;
}

.title-container img {
  height: 100%;
}

.wheel-container {
  display: flex;
  width: 80%;
}
</style>
